module.exports = __webpack_public_path__ + "static/media/Mission_Accomplished.c224a48f.png";